/**
 * Fallback payload for the hero whitespace grid.
 *
 * The grid shows fictional accounts priced from the marketing catalog — nothing
 * about it is per-visitor or live, so it must not depend on the backend being
 * reachable. WhitespaceGrid prefers the API (so a running backend still drives
 * it) and falls back to this snapshot, which keeps the hero intact when the
 * site is served statically.
 *
 * Captured from GET /api/marketing/demo-whitespace.
 */
const demoWhitespace = {
  "modules": [
    "Core Platform",
    "Analytics",
    "Premium Support",
    "Onboarding"
  ],
  "rows": [
    {
      "id": "d-1",
      "name": "Harbourline Logistics",
      "region": "EMEA",
      "arr": 84000,
      "renewal": "2026-11-30",
      "seats": 120,
      "cells": [
        {
          "module": "Core Platform",
          "status": "live",
          "list_annual": null
        },
        {
          "module": "Analytics",
          "status": "ws",
          "list_annual": 4000,
          "sku": "ADDON-ANALYTICS",
          "quantity": 1,
          "pricing_unit": "flat"
        },
        {
          "module": "Premium Support",
          "status": "live",
          "list_annual": null
        },
        {
          "module": "Onboarding",
          "status": "n/a",
          "list_annual": null
        }
      ],
      "headroom": 4000.0
    },
    {
      "id": "d-2",
      "name": "Meridian Health Group",
      "region": "NA",
      "arr": 132000,
      "renewal": "2027-02-15",
      "seats": 260,
      "cells": [
        {
          "module": "Core Platform",
          "status": "live",
          "list_annual": null
        },
        {
          "module": "Analytics",
          "status": "impl",
          "list_annual": null
        },
        {
          "module": "Premium Support",
          "status": "ws",
          "list_annual": 3000,
          "sku": "ADDON-SUPPORT",
          "quantity": 1,
          "pricing_unit": "flat"
        },
        {
          "module": "Onboarding",
          "status": "n/a",
          "list_annual": null
        }
      ],
      "headroom": 3000.0
    },
    {
      "id": "d-3",
      "name": "Atlas Finance",
      "region": "NA",
      "arr": 46000,
      "renewal": "2026-10-01",
      "seats": 45,
      "cells": [
        {
          "module": "Core Platform",
          "status": "live",
          "list_annual": null
        },
        {
          "module": "Analytics",
          "status": "ws",
          "list_annual": 4000,
          "sku": "ADDON-ANALYTICS",
          "quantity": 1,
          "pricing_unit": "flat"
        },
        {
          "module": "Premium Support",
          "status": "ws",
          "list_annual": 3000,
          "sku": "ADDON-SUPPORT",
          "quantity": 1,
          "pricing_unit": "flat"
        },
        {
          "module": "Onboarding",
          "status": "n/a",
          "list_annual": null
        }
      ],
      "headroom": 7000.0
    },
    {
      "id": "d-4",
      "name": "Ironpeak Systems",
      "region": "APAC",
      "arr": 210000,
      "renewal": "2027-06-30",
      "seats": 410,
      "cells": [
        {
          "module": "Core Platform",
          "status": "live",
          "list_annual": null
        },
        {
          "module": "Analytics",
          "status": "live",
          "list_annual": null
        },
        {
          "module": "Premium Support",
          "status": "live",
          "list_annual": null
        },
        {
          "module": "Onboarding",
          "status": "n/a",
          "list_annual": null
        }
      ],
      "headroom": 0.0
    },
    {
      "id": "d-5",
      "name": "Bluewater Retail",
      "region": "EMEA",
      "arr": 61000,
      "renewal": "2026-12-31",
      "seats": 90,
      "cells": [
        {
          "module": "Core Platform",
          "status": "live",
          "list_annual": null
        },
        {
          "module": "Analytics",
          "status": "ws",
          "list_annual": 4000,
          "sku": "ADDON-ANALYTICS",
          "quantity": 1,
          "pricing_unit": "flat"
        },
        {
          "module": "Premium Support",
          "status": "impl",
          "list_annual": null
        },
        {
          "module": "Onboarding",
          "status": "n/a",
          "list_annual": null
        }
      ],
      "headroom": 4000.0
    },
    {
      "id": "d-6",
      "name": "Summit Legal",
      "region": "NA",
      "arr": 27000,
      "renewal": "2027-03-31",
      "seats": 30,
      "cells": [
        {
          "module": "Core Platform",
          "status": "live",
          "list_annual": null
        },
        {
          "module": "Analytics",
          "status": "ws",
          "list_annual": 4000,
          "sku": "ADDON-ANALYTICS",
          "quantity": 1,
          "pricing_unit": "flat"
        },
        {
          "module": "Premium Support",
          "status": "ws",
          "list_annual": 3000,
          "sku": "ADDON-SUPPORT",
          "quantity": 1,
          "pricing_unit": "flat"
        },
        {
          "module": "Onboarding",
          "status": "ws",
          "list_annual": 2500,
          "sku": "ADDON-ONBOARD",
          "quantity": 1,
          "pricing_unit": "flat"
        }
      ],
      "headroom": 9500.0
    }
  ],
  "totals": {
    "arr": 560000,
    "headroom": 27500.0
  }
};

export default demoWhitespace;
